/**
 * Tipi di notifiche per il sistema calendario
 */
export const NOTIFICATION_TYPES = {
  REMINDER_30MIN: { 
    icon: '🔴', 
    priority: 'high',
    label: 'Tra 30 minuti',
    color: 'text-red-600 bg-red-50 border-red-200',
    urgency: 5
  },
  REMINDER_1HOUR: { 
    icon: '🟡', 
    priority: 'medium',
    label: 'Tra 1 ora', 
    color: 'text-yellow-600 bg-yellow-50 border-yellow-200',
    urgency: 4
  },
  // ✅ NUOVO: Aggiunto tipo per eventi entro 3 ore
  REMINDER_3HOURS: { 
    icon: '🟠', 
    priority: 'medium',
    label: 'Nelle prossime ore',
    color: 'text-orange-600 bg-orange-50 border-orange-200',
    urgency: 4
  },
  REMINDER_1DAY: { 
    icon: '🟢', 
    priority: 'low',
    label: 'Oggi',
    color: 'text-green-600 bg-green-50 border-green-200',
    urgency: 2
  },
  // ✅ NUOVO: Aggiunto tipo per eventi futuri
  FUTURE_EVENT: { 
    icon: '📅', 
    priority: 'low',
    label: 'Futuro',
    color: 'text-blue-600 bg-blue-50 border-blue-200',
    urgency: 1
  },
  PARTICIPANT_EVENT: { 
    icon: '🔵', 
    priority: 'medium',
    label: 'Come partecipante',
    color: 'text-blue-600 bg-blue-50 border-blue-200',
    urgency: 3
  },
  EVENT_CREATED: { 
    icon: '🟢', 
    priority: 'low',
    label: 'Evento creato',
    color: 'text-green-600 bg-green-50 border-green-200',
    urgency: 1
  },
  EVENT_UPDATED: { 
    icon: '🟣', 
    priority: 'low',
    label: 'Evento modificato',
    color: 'text-purple-600 bg-purple-50 border-purple-200',
    urgency: 1
  },
  EVENT_CANCELLED: { 
    icon: '⚫', 
    priority: 'high',
    label: 'Evento cancellato',
    color: 'text-gray-600 bg-gray-50 border-gray-200',
    urgency: 5
  },
  PUBLIC_EVENT: { 
    icon: '🌐', 
    priority: 'medium',
    label: 'Evento pubblico',
    color: 'text-green-600 bg-green-50 border-green-200',
    urgency: 3
  }
};

/**
 * Priorità ordinate per urgenza
 */
export const NOTIFICATION_URGENCY_ORDER = [
  'REMINDER_30MIN',
  'EVENT_CANCELLED', 
  'REMINDER_1HOUR',
  'REMINDER_3HOURS', // ✅ AGGIUNTO
  'PARTICIPANT_EVENT',
  'REMINDER_1DAY',
  'FUTURE_EVENT', // ✅ AGGIUNTO
  'EVENT_UPDATED',
  'EVENT_CREATED'
];

/**
 * ✅ AGGIORNATO: Configurazione colori per tipi evento da DATABASE
 * Corrisponde ai dati in DOM_TipiEventi
 */
export const EVENT_TYPE_COLORS = {
  1: { 
    color: '#6B7280', 
    bg: 'bg-gray-500', 
    text: 'text-white',
    codice: 'SEDE',
    descrizione: 'Sede Arezzo',
    icon: '🏢'
  },
  2: { 
    color: '#F59E0B', 
    bg: 'bg-amber-500', 
    text: 'text-white',
    codice: 'FERIE',
    descrizione: 'Ferie',
    icon: '🏖️'
  },
  3: { 
    color: '#8B5CF6', 
    bg: 'bg-purple-500', 
    text: 'text-white',
    codice: 'PERMESSI',
    descrizione: 'Permessi',
    icon: '⏰'
  },
  4: { 
    color: '#3B82F6', 
    bg: 'bg-blue-500', 
    text: 'text-white',
    codice: 'WEBMEETING',
    descrizione: 'Web Meeting',
    icon: '💻'
  },
  5: { 
    color: '#10B981', 
    bg: 'bg-green-500', 
    text: 'text-white',
    codice: 'RIUNIONE',
    descrizione: 'Riunione',
    icon: '👥'
  },
  8: { 
    color: '#F97316', 
    bg: 'bg-orange-500', 
    text: 'text-white',
    codice: 'ATTIVITA',
    descrizione: 'Attività',
    icon: '📋'
  },
  9: { 
    color: '#EF4444', 
    bg: 'bg-red-500', 
    text: 'text-white',
    codice: 'MALATTIA',
    descrizione: 'Malattia',
    icon: '🏥'
  }
};

/**
 * ✅ NUOVA: Funzione helper per ottenere info tipo evento
 */
export const getEventTypeInfo = (tipoEventoId) => {
  return EVENT_TYPE_COLORS[tipoEventoId] || {
    color: '#6B7280',
    bg: 'bg-gray-500',
    text: 'text-white',
    codice: 'UNKNOWN',
    descrizione: 'Sconosciuto',
    icon: '❓'
  };
};

/**
 * ✅ NUOVA: Funzione helper per ottenere nome tipo evento
 */
export const getEventTypeName = (tipoEventoId) => {
  const typeInfo = getEventTypeInfo(tipoEventoId);
  return typeInfo.descrizione;
};

/**
 * Configurazione icone per tipi evento
 */
export const EVENT_TYPE_ICONS = {
  1: '🏢', // Sede
  2: '🏖️', // Ferie
  3: '⏰', // Permessi
  4: '💻', // WebMeeting
  5: '👥', // Riunione
  8: '📋'  // Attività
};

/**
 * Configurazione timeline per vista settimanale
 */
export const WEEK_VIEW_CONFIG = {
  startHour: 8,
  endHour: 20,
  slotDuration: 30, // minuti
  showWeekends: true,
  dayLabels: ['Dom', 'Lun', 'Mar', 'Mer', 'Gio', 'Ven', 'Sab'],
  monthLabels: [
    'Gennaio', 'Febbraio', 'Marzo', 'Aprile', 'Maggio', 'Giugno',
    'Luglio', 'Agosto', 'Settembre', 'Ottobre', 'Novembre', 'Dicembre'
  ]
};